import RadioSelector from "./RadioSelector";
import React, {useState} from "react";
import IconCarValidated from "../../assets/v2/badge-check.png";
import VehicleHelper from "../../helpers/VehicleHelper";

export default function VehicleSelector({
                                            vehicleList,
                                            selectedVehicleId,
                                            vehicleSelectedHandler
                                        }) {

    return <RadioSelector id="vehicle"
                          version={"list"}
                          value={selectedVehicleId}
                          values={vehicleList.map((vehicle) => {
                              return {
                                  value: vehicle.id,
                                  label: <div className="flex">
                                      <div>{vehicle.brand} {vehicle.model} [{vehicle.licence_plate}]</div>
                                      {VehicleHelper.IsVehicleValidated(vehicle) ?
                                          <img src={IconCarValidated} className="w-[24px] h-[24px] ml-2"/> : null}
                                  </div>
                              }
                          })}
                          onChange={vehicleSelectedHandler}/>
}